import { useState, useEffect, useCallback } from 'react';


// import { personService } from '../services';
import { deviceService } from '../services';

// import type { PersonFormData } from '../types/person';
import type { Device } from '../types/device';


interface UseDeviceResult {
  data: Device[];
  loading: boolean;
  error: string | null;
  openDoor: (deviceId: number) => void;
  // total: number;
  // totalPages: number;
  // refetch: () => void;
  // updateStatus: (statusId: number, employee_id: string) => Promise<void>;
  // createPersonComplete: (formData: PersonFormData) => Promise<{ success: boolean, personId?: string, message?: string }>,
  // updating: boolean;
  // creating: boolean;
}



export const useDevice = (): UseDeviceResult => {
  const [data, setData] = useState<Device[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // const [total, setTotal] = useState(0);
  // const [totalPages, setTotalPages] = useState(0);
  // const [updating, setUpdating] = useState(false);
  // const [creating, setCreating] = useState(false); // ✅ Para creación

  const fetchDevice = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await deviceService.getDevices();
      setData(response);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
      console.error('Error fetching empleados:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDevice();
  }, [fetchDevice]);

  // const refetch = useCallback(async () => {
  //   try {
  //     const syncFacialResult = await personService.syncFacial('1');
  //     if (!syncFacialResult) {
  //       throw new Error('Error al actualizar facial');
  //     }
  //     fetchDevice();
  //   }
  //   catch (err) {
  //     const errorMessage = err instanceof Error ? err.message : 'Error en actualizar';
  //     setError(errorMessage);
  //   }
  // }, [fetchDevice]);

  const openDoor = useCallback(async (deviceId: number) => {
    try {
      // setUpdating(true);
      setError(null);
      const response = await deviceService.openDoor(deviceId);
      if (!response) {
        throw new Error('No se realizó la apertura de la puerta');
      }

      // Opcional: refetch para asegurar consistencia con el servidor
      // await fetchPerson();

    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error al actualizar status';
      setError(errorMessage);
      console.error('Error updating person status:', err);

      // En caso de error, revertir el cambio optimista haciendo refetch
      await fetchDevice();

      // Re-lanzar el error para que el componente pueda manejarlo
      throw err;
    } finally {
      // setUpdating(false);
    }
  }, [fetchDevice]);





  return {
    data,
    loading,
    error,
    openDoor
  };
};